import React, { useState, useEffect } from 'react';
import AuthCard from './AuthCard';
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';
const Invalidlink = ({ logoUrl, slug }) => {
    return (
        <AuthCard logoUrl={logoUrl}>
            <div className="ac-body">
            <div className="ac-icon ac-icon-warn">
                <span style={{ fontSize: '24px' }}><WarningAmberOutlinedIcon /></span>
            </div>

            <div className="ac-top">
                <div className="ac-title">This link is no longer valid</div>
                <div className="ac-sub">It may have expired or already been used. Links are single-use and time-limited for security.</div>
            </div>           

            <button
                className="ac-btn-primary"
                onClick={() => { window.location.href = '/signup/'+slug; }}
            >
                Go to sign in
            </button>
            </div>
            <div className="ac-footer" />
        </AuthCard>
    );
}

export default Invalidlink;